import React, { Component, Fragment, useState, useEffect } from "react";

import { compose } from "recompose";
import "views/Pma/PmaEditor/TableQuadrants/table-quadrants-editor.scss";
import { withSnackbar } from "notistack";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditQuadrantModal = (props) => {
  const {
    oldQuadrantData,
    handleInputChange,
    editQuadrantFormData,
    onCloseFn,
    modalType,
    areaID,
    onEditFormSubmit,
    selectedQuadrantNumber,
    handleRestoreDefault,
    titleEdit,
    maxMainTitleLength,
    mlsAreas,
    savingMessageShowing,
  } = props;
  // const { }

  if (!editQuadrantFormData.ddAreaSubTitle) {
    editQuadrantFormData.ddAreaSubTitle = "-";
  }
  if (titleEdit) {
    const { ddAreaTitle } = editQuadrantFormData;

    let overMaxMainTitleLength =
      ddAreaTitle &&
      ddAreaTitle.length &&
      ddAreaTitle.length >= maxMainTitleLength;
    return (
      <Fragment>
        <div className="design-details-edit-quadrant-container">
          <div className="design-details-edit-quadrant-form design-details-new-props">
            <div className="design-details-edit-quadrant-form-title-container">
              <p className="design-details-edit-quadrant-form-title-text">
                You Can Make Changes to the Title Here
              </p>
            </div>

            <div className="design-details-edit-quadrant-form-body">
              <div className="design-details-edit-form-body-col">
                <div className="design-details-edit-form-thead">
                  <div>
                    <p>Title </p>
                  </div>
                </div>
                <div className="design-details-edit-form-input design-details-main-title-input">
                  <div className="design-details-address-input-col">
                    <input
                      type="text"
                      id={`main-title`}
                      name={`ddAreaTitle`}
                      className="design-details-title-input"
                      value={ddAreaTitle || ""}
                      onChange={handleInputChange}
                      placeholder={ddAreaTitle}
                      maxLength={maxMainTitleLength}
                    ></input>
                    <label
                      htmlFor="quadrantsTitle"
                      className={
                        overMaxMainTitleLength ? "character-count-error" : ""
                      }
                    >
                      Character count:{" "}
                      {ddAreaTitle && ddAreaTitle.length
                        ? ddAreaTitle.length
                        : "0"}
                      /{maxMainTitleLength}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="design-details-edit-form-button-container">
            <div className="design-details-button-col">
              <div
                className="design-details-edit-form-cancel-button"
                onClick={onCloseFn}
              >
                <p>Close</p>
              </div>
            </div>
            <div className="design-details-button-col">
              <div
                className="design-details-edit-form-submit-button"
                onClick={onEditFormSubmit}
              >
                <p>Save</p>
              </div>
            </div>
          </div>
          {savingMessageShowing && (
            <div className="design-details-saving-message">
              Your work has been saved!
            </div>
          )}
        </div>
      </Fragment>
    );
  } else {
    let quadrantTitle =
      editQuadrantFormData[`dd${selectedQuadrantNumber}Title`];
    let quadrantText = editQuadrantFormData[`dd${selectedQuadrantNumber}Text`];

    // let quadrantText = editQuadrantFormData[selectedQuadrantNumber].text;

    let maxQuadrantTextLength = selectedQuadrantNumber === 4 ? 250 : 320;
    let overMaxQuadrantTextLength =
      quadrantText &&
      quadrantText.length &&
      quadrantText.length >= maxQuadrantTextLength;

    let maxQuadrantTitleLength = 40;
    let overMaxQuadrantTitleLength =
      quadrantTitle &&
      quadrantTitle.length &&
      quadrantTitle.length >= maxQuadrantTitleLength;

    return (
      <Fragment>
        <div className="design-details-edit-quadrant-container">
          <div className="design-details-edit-quadrant-form design-details-new-props">
            <div className="design-details-edit-quadrant-form-title-container">
              <p className="design-details-edit-quadrant-form-title-text">
                You Can Make Changes
              </p>
              <p className="design-details-edit-quadrant-form-title-text">
                to the Title and Text Here
              </p>
            </div>
            <div className="design-details-edit-quadrant-form-body design-details-row-body">
              <div className="design-details-edit-form-body-col">
                <div className="design-details-edit-form-thead">
                  <div>
                    <p>Title</p>
                  </div>
                </div>
                <div className="design-details-edit-form-input">
                  <div className="design-details-address-input-col">
                    <input
                      type="text"
                      id={`dd${selectedQuadrantNumber}Title`}
                      name={`dd${selectedQuadrantNumber}Title`}
                      className="design-details-title-input"
                      value={quadrantTitle || ""}
                      onChange={handleInputChange}
                      placeholder={quadrantTitle}
                      maxLength={maxQuadrantTitleLength}
                    ></input>
                    <label
                      htmlFor={`dd${selectedQuadrantNumber}Title`}
                      className={
                        overMaxQuadrantTitleLength
                          ? "character-count-error"
                          : ""
                      }
                    >
                      Character count:{" "}
                      {quadrantTitle && quadrantTitle.length
                        ? quadrantTitle.length
                        : "0"}
                      /{maxQuadrantTitleLength}
                    </label>
                  </div>
                </div>
              </div>

              <div className="design-details-edit-form-body-col">
                <div className="design-details-edit-form-thead">
                  <div>
                    <p>Text</p>
                  </div>
                </div>
                <div className="design-details-edit-form-input">
                  <div className="design-details-address-input-col">
                    <textarea
                      placeholder={quadrantText}
                      onChange={handleInputChange}
                      name={`dd${selectedQuadrantNumber}Text`}
                      value={quadrantText || ""}
                      className="design-details-quadrant-textarea"
                      maxLength={maxQuadrantTextLength}
                    ></textarea>

                    <label
                      htmlFor={`dd${selectedQuadrantNumber}Text`}
                      className={
                        overMaxQuadrantTextLength ? "character-count-error" : ""
                      }
                    >
                      Character count:{" "}
                      {quadrantText && quadrantText.length
                        ? quadrantText.length
                        : "0"}
                      /{maxQuadrantTextLength}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="design-details-edit-form-button-container">
            <div className="design-details-button-col">
              <div
                className="design-details-edit-form-cancel-button"
                onClick={onCloseFn}
              >
                <p>Close</p>
              </div>
              {/*<div className="restore-default" onClick={handleRestoreDefault}>
                <p>Restore Default</p>
              </div>*/}
            </div>
            <div className="design-details-button-col">
              <div
                className="design-details-edit-form-submit-button"
                onClick={onEditFormSubmit}
              >
                <p>Save</p>
              </div>
            </div>
          </div>
          {savingMessageShowing && (
            <div className="design-details-saving-message">
              Your work has been saved!
            </div>
          )}
        </div>
        {/*</Dialog>*/}
      </Fragment>
    );
  }
};

export default compose(withSnackbar)(EditQuadrantModal);
